import { render, staticRenderFns } from "./PayoutListFiltersChip.vue?vue&type=template&id=1d20a040&scoped=true&lang=pug&"
import script from "./PayoutListFiltersChip.vue?vue&type=script&lang=js&"
export * from "./PayoutListFiltersChip.vue?vue&type=script&lang=js&"
import style0 from "./PayoutListFiltersChip.vue?vue&type=style&index=0&id=1d20a040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d20a040",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VContainer,VIcon,VSpacer})
